import EmployeeFormModal from 'components/NewModal/EmployeeFormModal';

const EmployeeEditModal = EmployeeFormModal;
export default EmployeeEditModal;
